<template scoped>
  <b-modal
    v-model="trigger"
    :id="id"
    :ok-title="okTitle"
    :title="title"
    @ok="eventOk($event)"
    @cancel="eventCancel($event)"
    :centered="centered"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :ok-only="okOnly"
  >
    <p class="my-4">{{text}}</p>
  </b-modal>
</template>
<script>
export default {
  props: [
    "trigger",
    "text",
    "okTitle",
    "okOnly",
    "id",
    "title",
    "centered",
    "dontCloseWhenClickedOutside",
    "dontCloseWhenEscapePressed",
    "dontShowCloseIcon"
  ],
  methods: {
    eventOk(event) {
      this.$emit("eventOk", event);
    },
    eventCancel(event) {
      this.$emit("eventCancel", event);
    }
  }
};
</script>

<style scoped>
</style>
